import React from 'react';
import { Award, Users, Eye, Grid } from 'lucide-react';
import { whyChooseUs } from '../utils/mock';

const iconMap = {
  Award: Award,
  Users: Users,
  Eye: Eye,
  Grid: Grid
};

const About = () => {
  return (
    <section id="about" className="py-24 bg-slate-50">
      <div className="container mx-auto px-4">
        <div className="grid lg:grid-cols-2 gap-16 items-center mb-20">
          {/* Image */}
          <div className="relative">
            <div className="absolute inset-0 bg-gradient-to-br from-amber-500/20 to-transparent rounded-2xl transform translate-x-6 translate-y-6"></div>
            <img
              src="https://images.unsplash.com/photo-1573164574572-cb89e39749b4"
              alt="Rubicon Team"
              className="relative rounded-2xl shadow-2xl w-full h-[500px] object-cover" />

            <div className="absolute -bottom-6 -right-6 bg-amber-600 text-white p-6 rounded-xl shadow-xl">
              <p className="text-4xl font-bold">17+</p>
              <p className="text-sm">Years of Excellence</p>
            </div>
          </div>

          {/* Content */}
          <div>
            <div className="inline-block bg-amber-100 text-amber-700 px-4 py-2 rounded-full text-sm font-semibold mb-4">
              About Rubicon Finservices
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6">
              Your Partner in 
              <span className="text-amber-600"> Financial Success</span>
            </h2>
            <p className="text-lg text-slate-600 mb-6 leading-relaxed">
              At Rubicon Finservices, we believe that financial freedom is within everyone's reach. 
              With over a decade of experience in wealth management and financial planning, we've helped 
              thousands of clients achieve their financial goals.
            </p>
            
            <div className="text-lg leading-relaxed text-slate-600 space-y-4 mb-8">
              <p>
                Rubicon Finservices is a leading mutual fund distribution firm based in Kolkata, founded and led by <span className="font-bold text-slate-900">Rohit Jain Bhansali</span>. With a successful track record spanning over 15 years, Rubicon Finservices has earned a reputation as a trusted Mutual Fund Distributor for a diverse clientele.
              </p>
              <p>
                At Rubicon Finservices, we cater to a wide range of clients, including businessmen, family offices, industrialists, fund managers, NRIs (Non-Residential Indians), film industry professionals, fashion designers, and more. We understand that each client has unique financial goals, risk tolerance, and preferences. Therefore, we offer personalized investment strategies tailored to individual needs, ensuring that our clients wealth is optimally managed.
              </p>
              <p>
                Rubicon Finservices takes pride in its commitment to client satisfaction. We believe in building long-term partnerships based on trust, transparency, and integrity. Our proactive approach to communication ensures that clients are always informed about market developments and the performance of their portfolios. We strive to exceed expectations by providing ongoing support and recommending adjustments as needed to align with changing market conditions.
              </p>
              <p>
                The firm is guided by the invaluable expertise of <span className="font-bold text-slate-900">Mr. Prem Prakash Bhansali</span>, a renowned figure in the financial industry and the chief mentor of Rubicon Finservices. His extensive knowledge, experience and networking skills further strengthen our capabilities.
              </p>
              
              <p className="mt-6 pt-6 border-t-2 border-slate-300">
                <span className="text-slate-900 font-bold italic text-xl block leading-relaxed">
                  "If you think about the long term then you can really make good life decisions that you won't regret later."
                </span>
              </p>
            </div>

            <div className="grid grid-cols-2 gap-4">
              <div className="bg-white p-6 rounded-xl shadow-md border border-slate-200">
                <p className="text-3xl font-bold text-amber-600 mb-2">500+</p>
                <p className="text-slate-600 font-medium">Satisfied Clients</p>
              </div>
              <div className="bg-white p-6 rounded-xl shadow-md border border-slate-200">
                <p className="text-3xl font-bold text-amber-600 mb-2">40+</p>
                <p className="text-slate-600 font-medium">Partner AMCs</p>
              </div>
            </div>
          </div>
        </div>

        {/* Why Choose Us */}
        <div className="text-center mb-12">
          <h3 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">
            Why Choose Rubicon Finservices?
          </h3>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">
            We combine expertise, transparency, and personalized service to help you build lasting wealth
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {whyChooseUs.map((item) => {
            const IconComponent = iconMap[item.icon];
            return (
              <div
                key={item.id}
                className="bg-white p-8 rounded-xl shadow-lg border border-slate-200 hover:shadow-2xl hover:border-amber-200 transition-all duration-300 group">

                <div className="w-14 h-14 bg-gradient-to-br from-amber-500 to-amber-600 rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                  <IconComponent className="text-white" size={28} />
                </div>
                <h4 className="text-xl font-bold text-slate-900 mb-3">{item.title}</h4>
                <p className="text-slate-600 leading-relaxed">{item.description}</p>
              </div>);

          })}
        </div>
      </div>
    </section>);

};

export default About;